// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"604":"6a51a7dc","700":"1333260a","704":"672bb789","737":"6bcb171c"}[chunkId] + ".chunk.css";
};